import { Route, Switch} from 'react-router-dom';

/*Componentes */
import Inicio from './components/portada/index';
import Error_404 from './components/Error_404';
import Contenido from './components/contenido';
import ScrollToTop from './utilities/ScrollToTop';
function App() {
  return (
    <ScrollToTop>
        <Switch>
          <Route exact path="/" component={Inicio} />
          <Route exact path="/contenido/:page" component={Contenido} />
          <Route component={Error_404} />
        </Switch>
    </ScrollToTop>
  );
}

export default App;
